<template>
    <main class="container-fluid" style="max-width: 500px">

        <div class="card my-5 px-5 py-3 shadow">
            <div class="mt-2  text-center">
                    <p class="">
                    <i class="fa-regular fa-circle-check icon"></i>
                    </p>
                    <p class="mt-3" style="font-size:18px;"><strong>Agendamento cancelado com sucesso!</strong>
                    </p>
                    <div class="botoes">
                        <button class="btn mb-1 w-100 mt-1 d-none" type="button" @click="agendarConsulta">
                          Realizar novo agendamento
                        </button>   
                        <button class="btn mb-1 w-100 mt-1" type="button" @click="irParaAgendamentos">
                          Ir para agendamentos
                        </button> 
                    </div>
             </div>
        </div>
    </main>
</template>

<script>

//   import { APITeleMedicinaService } from "@/service/tele-medicina/APITeleMedicinaService";
//   const apiTeleMedicinaService = new APITeleMedicinaService();
//   import Loading from "@/components/Loading.vue";

  export default {
    name: "AgendamentoCancelado",
    components: { 
        // Loading
    },
    methods: {
      agendarConsulta(){
        this.$router.push(`/servico/tele-medicina/agendamento`);         
        window.scrollTo(0, 0);
      },
      irParaAgendamentos(){
        this.$router.push(`/servico/tele-medicina/agendamento`);         
        window.scrollTo(0, 0);
      }
    }
  };
  </script>
  
  <style scoped>
  .detalhes {
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 5px;
    margin-top: 20px;
  }
  
  .card {
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 10px;
    cursor: pointer;
  }
  
   
  .informacoes {
    flex: 1;
  }
  
  .botoes {
    margin-top: 10px;
  }
  
  .botoes button {
    margin-right: 10px;
  }
  </style>
  